import { SupportAdminConditionComponent } from "../../../components/SupportSystem/Admin/SupportAdminConditionComponent"
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
export function SupportAdminConditionContainer () {
    const titleName = "รายละเอียดเงื่อนไข";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem  />
            <HeadTitle title={titleName} />
            <SupportAdminConditionComponent/>
            <Footer />
        </div>   
    )
}